import { render, staticRenderFns } from "./managementList.vue?vue&type=template&id=3fbf6f54&scoped=true&"
import script from "./managementList.vue?vue&type=script&lang=js&"
export * from "./managementList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbf6f54",
  null
  
)

export default component.exports